import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../ui/select';
import DefaultDoctorIcon from '@/assets/image/circule_doctor_any.png';
import NoPhotoDoctorIcon from '@/assets/image/circule_doctor_no_img.png';
import OlgaImg from '@/assets/image/olga_dok.png';
import MarfaImg from '@/assets/image/marfa_dok.png';
import MajImg from '@/assets/image/maj_dok.png';
import MarchinImg from '@/assets/image/dok_marchin.png';
import DmitryImg from '@/assets/image/dmitry_dok.png';
import LeszekImg from '@/assets/image/leszek_rymsza_smal.png';
import ZlataImg from '@/assets/image/zlata_pichuhina_smal.png';
import IgaImg from '@/assets/image/iga_kozłowska_cir.png';
import MarharytaImg from '@/assets/image/marharyta_sementsova_cir.png';

type Doctor = {
  id: string;
  name: string;
  office_id: string[] | number[];
};

interface DoctorsSelectProps {
  value: {id: string; name: string};
  onChange: (val: {id: string; name: string}) => void;
  officeId?: string;
  doctors: Doctor[];
  availableDoctorIds?: Set<string>;
}

const DoctorsSelect = ({
  value,
  onChange,
  officeId,
  doctors,
  availableDoctorIds
}: DoctorsSelectProps) => {

  const handleChange = (val: string) => {
    if (val === '999') {
      onChange({id: '', name: 'Dowolny lekarz'});
      // return;
    }
    const selectedDoctor = doctors.find(
      (doc) => String(doc.id) === String(val)
    );
    if (selectedDoctor) {
      onChange({id: String(selectedDoctor.id), name: selectedDoctor.name});
    }
  };

  // Фільтрація лікарів по officeId міста
  let filteredDoctors: Doctor[] = doctors || [];
  if (officeId && doctors.length > 0) {
    const officeIds = officeId
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);

    filteredDoctors = doctors.filter((doctor) =>
      doctor.office_id.some((office_id) =>
        officeIds.includes(String(office_id))
      )
    );
  }

  // Додатково фільтруємо за наявністю слотів (за даними schedule)
  if (availableDoctorIds && availableDoctorIds.size > 0) {
    filteredDoctors = filteredDoctors.filter((doctor) =>
      availableDoctorIds.has(String(doctor.id))
    );
  }

  const getDoctorImage = (doctor?: {id?: string; name?: string}) => {
    const idStr = String(doctor?.id || '');
    switch (idStr) {
      case '21':
        return OlgaImg;
      case '33':
        return MarfaImg;
      case '31':
        return MajImg;
      case '35':
        return IgaImg;
      case '34':
        return MarharytaImg;
      case '43':
        return MarchinImg;
      case '18':
        return DmitryImg;  
      case '45':
        return LeszekImg;
      case '48':
        return ZlataImg;
      default:
        return NoPhotoDoctorIcon;
    }
  };



  return (
    <div className='r-form-field-item-container'>
      <h3 className='mb-2 text-lg font-semibold text-center sm:text-left'>
        Wybierz lekarza
      </h3>
      <Select value={value?.id || ''} onValueChange={handleChange}>
        <SelectTrigger
          className={`w-full h-[50px] text-base  ${
            value?.id
              ? 'text-text-primary font-semibold'
              : 'text-text-primary font-semibold'
          }`}
        >
          <div className='flex items-center gap-3'>
            {!value?.id && (
              <img
                src={DefaultDoctorIcon}
                alt=''
                className='h-8 w-8 rounded-full object-cover'
              />
            )}
            <SelectValue placeholder={<span>Dowolny lekarz</span>} />
          </div>
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectItem
              key={String(0)}
              value={String(999)}
              data-doctor-office-ids={[]}
              className='pl-2 mb-1 font-normal'
            >
              <>
                <img
                  src={DefaultDoctorIcon}
                  alt=''
                  style={{zIndex: 50}}
                  className='h-8 w-8 rounded-full object-cover relative'
                />
                <span>Dowolny lekarz</span>
              </>
            </SelectItem>
            <div className='h-[1px] w-[calc(100%-16px)] bg-[#E0E0E0] mb-1 ml-2 '></div>
            {filteredDoctors.map((doctor) => (
              <SelectItem
                key={String(doctor.id)}
                value={String(doctor.id)}
                data-doctor-office-ids={doctor.office_id}
                className='pl-2 font-normal'
              >
                <>
                  <img
                    src={getDoctorImage({
                      id: String(doctor.id),
                      name: doctor.name
                    })}
                    alt=''
                    style={{zIndex: 50}}
                    className='h-8 w-8 rounded-full object-cover relative'
                  />
                  <span>{doctor.name}</span>
                </>
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default DoctorsSelect;
